<template>
  <el-row class="cs-contentContainer">
    <el-col
      :span="4"
      class="cs-main-left-container"
    >
      <navigator></navigator>
    </el-col>
    <el-col
      :span="20"
      class="backgroud-gray cs-fullHeight cs-main-right-container"
    >
      <div
        style=""
        class="cs-fullHeight cs-contentContainer-right"
      >
        <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
          <el-row v-if="isStudentHimself">
            <el-col>
              <span class="cs-title">个人信息</span>
              <el-row class="hidden-xs-only">
                <el-col :span="18">
                  <label> &nbsp; </label>
                </el-col>
              </el-row>
              <el-row class="grid-content">
                <el-row>
                  <el-col :span="4"
                          :xs="8"
                          class="text-right">
                    <strong><label class="el-form-item__label float-right">手机号码：</label></strong>
                  </el-col>
                  <el-col :span="8"
                          :xs="8">
                    <label class="el-form-item__content"
                           v-text="form.Phone"></label>
                  </el-col>
                  <el-col :span="10"
                          :xs="8">
                    <el-button type="primary"
                               size="medium"
                               @click="edit('phone')">更改号码</el-button>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4"
                          :xs="8"
                          class="text-right">
                    <strong><label class="el-form-item__label float-right">学校：</label></strong>
                  </el-col>
                  <el-col :span="8"
                          :xs="8">
                    <label class="el-form-item__content"
                           v-text="form.UniversityName"></label>
                  </el-col>
                  <el-col :span="10"
                          :xs="8">
                    <el-button type="primary"
                               size="medium"
                               @click="edit('university')">更改学校</el-button>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4"
                          :xs="8"
                          class="text-right">
                    <strong><label class="el-form-item__label float-right">邮箱：</label></strong>
                  </el-col>
                  <el-col :span="8"
                          :xs="8">
                    <label class="el-form-item__content"
                           v-text="form.Email"></label>
                  </el-col>
                  <el-col :span="10"
                          :xs="8">
                    <el-button type="primary"
                               size="medium"
                               @click="edit('email')">更改邮箱</el-button>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4"
                          :xs="8"
                          class="text-right">
                    <strong><label class="el-form-item__label float-right">密码：</label></strong>
                  </el-col>
                  <el-col :span="8"
                          :xs="8">
                    <label class="el-form-item__content"
                           style="width:40px;"
                           v-text="form.Password"></label>
                  </el-col>
                  <el-col :span="10"
                          :xs="8">
                    <el-button type="primary"
                               size="medium"
                               @click="edit('password')">更改密码</el-button>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col class="text-center">
                    <a :href="mobileAppLink">下载Android App</a>
                  </el-col>
                </el-row>
              </el-row>
            </el-col>
          </el-row>
          <el-row v-if="!isStudentHimself">
            <el-button type="text"
                       size="medium"
                       @click="onBack()">返回</el-button>
          </el-row>
          <div v-if="!form.IsStudyAbroad">
            <hr>
            <el-row>
              <el-col>
                <member-info ref="member-info"
                            :data-in="{
                              studentId: currentStudentId,
                              showTitle: true,
                              enableEdit: USERMANAGER.isAdmin || USERMANAGER.isFinancialManager || USERMANAGER.isExecutiveManager,
                              showPhone: USERMANAGER.isAdmin || USERMANAGER.isFinancialManager || USERMANAGER.isExecutiveManager,
                              enableResetPassword: USERMANAGER.isAdmin || USERMANAGER.isSales || USERMANAGER.isExecutiveManager || USERMANAGER.isAssistant || USERMANAGER.isReceptionist,
                              enableEditName: USERMANAGER.isAdmin || USERMANAGER.isSales || USERMANAGER.isReceptionist || USERMANAGER.isExecutiveManager,
                              enableResetAE: this.USERMANAGER.isAdmin || this.USERMANAGER.isRegionCEO || this.USERMANAGER.isCampusPresident || this.USERMANAGER.isExecutiveManager
                          }"></member-info>
              </el-col>
            </el-row>
            <hr>
            <el-row>
              <student-speedup-course-history :studentName="form.Phone" :student-id="currentStudentId" :enableEdit=" USERMANAGER.isAdmin || USERMANAGER.isSales || USERMANAGER.isFinancialManager || USERMANAGER.isExecutiveManager || USERMANAGER.isFinancialAssistant || USERMANAGER.isFinancialAccounting || USERMANAGER.isReceptionist || USERMANAGER.isAssistant"></student-speedup-course-history>
            </el-row>
          </div>
          <div v-if="!!form.IsStudyAbroad">
            <hr>
            <el-row>
              <saStudentInfo mode="simple" :showTitle="true" :showChannel="!isStudentHimself" :enableEdit="USERMANAGER.isAdmin || USERMANAGER.isSAManager || USERMANAGER.isSABusinessSales" :dataIn="saStudentInfoDataIn" />
            </el-row>
            <hr>
            <el-row>
              <studentSAServiceHistory :studentId="currentStudentId" />
            </el-row>
            <hr>
            <el-row>
              <studentSAServiceSummaryHistory :studentId="currentStudentId" />
            </el-row>
          </div>
          <hr>
          <el-row>
            <student-payment-history :student-id="currentStudentId"></student-payment-history>
          </el-row>
          <hr>
          <el-row>
            <student-receipt-history :student-id="currentStudentId"></student-receipt-history>
          </el-row>
          <div v-if="!form.IsStudyAbroad && false">
            <hr>
            <el-row>
              <studentBounsPointHistory :student-id="currentStudentId"></studentBounsPointHistory>
            </el-row>
            <hr>
            <el-row>
              <studentBalanceHistory :student-id="currentStudentId"></studentBalanceHistory>
            </el-row>
          </div>
        </div>
      </div>
    </el-col>
    <div v-if="isStudentHimself">
      <el-dialog
        title="更改号码"
        :close-on-click-modal="false"
        :visible.sync="phoneEditorVisible"
        top="8vh"
      >
        <phone-editor
          v-on:closeEditor="onCloseEditor"
          v-on:saveSuccess="onSaveSuccess"
        ></phone-editor>
      </el-dialog>
      <el-dialog
        title="更改学校"
        :close-on-click-modal="false"
        :visible.sync="universityEditorVisible"
        top="8vh"
      >
        <university-editor
          :universityId="form.UniversityId"
          v-on:closeEditor="onCloseEditor"
          v-on:saveSuccess="onSaveSuccess"
        ></university-editor>
      </el-dialog>
      <el-dialog
        title="更改邮箱"
        :close-on-click-modal="false"
        :visible.sync="emailEditorVisible"
        top="8vh"
      >
        <email-editor
          v-on:closeEditor="onCloseEditor"
          v-on:saveSuccess="onSaveSuccess"
        ></email-editor>
      </el-dialog>
      <el-dialog
        title="修改密码"
        :close-on-click-modal="false"
        :visible.sync="passwordEditorVisible"
        top="8vh"
      >
        <password-editor
          :type="'changePassword'"
          v-on:closeEditor="onCloseEditor"
          v-on:saveSuccess="onSaveSuccess"
        ></password-editor>
      </el-dialog>
    </div>
  </el-row>
</template>

<style lang="scss" scoped>
.cs-contentContainer {
  .grid-content {
    margin-top: 15px;

    .cs-schedule-buttonContainer {
      text-align: right;
    }
  }

  .cs-schedule-bottomButton {
    margin-top: 20px;
  }

  .course-row {
    height: 30px;
    padding: 5px;
    padding-left: 10px;
  }

  .odd-course-row {
    background: whitesmoke;
  }

  .even-course-row {
    background: #ebebeb;
  }

  .term-row {
    margin-top: 40px;
  }

  .term-title {
    margin-left: 10px;
    margin-bottom: 5px;
  }
}
</style>

<script>
import phoneEditor from "../components/phoneEditor";
import navigator from "../components/navigator";
import universityEditor from "../components/universityEditor.vue";
import passwordEditor from "../components/passwordEditor.vue";
import memberInfo from "../components/common/memberInfo.vue";
import studentSpeedupCourseHistory from "../components/studentProfile/studentSpeedupCourseHistory.vue";
import studentPaymentHistory from "../components/studentProfile/studentPaymentHistory.vue";
import studentBounsPointHistory from "../components/studentProfile/studentBounsPointHistory.vue";
import studentBalanceHistory from "../components/studentProfile/studentBalanceHistory.vue";
import studentReceiptHistory from "../components/studentProfile/studentReceiptHistory.vue";
import emailEditor from "../components/emailEditor";

import global_ from "../core/global";
import { getStore, setStore } from "../config/mUtils";
import { getStudent } from "../service/student.service";
import { getMobileAppLink } from "../service/common.service";
import { getStudyAbroadStudent } from "@/service/studyAbroad.service";

const defaultSAStudent = {
  StudentId: 0,
  StudentName: null,
  Phone: null,
  SaleAmountDiscountedCAD: 0,
  SaleAmountDiscountedCNY: 0,
  SaleAmountAvailableCAD: 0,
  SaleAmountAvailableCNY: 0,
  WorkflowCurrencyList: [],
  ChannelId: null,
  ChannelName: null,
  ChannelCurrency: null,
};

export default {
  data() {
    return {
      phoneEditorVisible: false,
      emailEditorVisible: false,
      universityEditorVisible: false,
      passwordEditorVisible: false,
      form: {
        Phone: "",
        UniversityName: "",
        Password: "********",
        UniversityId: 0,
        StudentId: 0,
        IsStudyAbroad: false
      },
      courseRecords: [],
      param: {},
      currentStudentId: 0,
      isStudentHimself: false,
      mobileAppLink: "",
      saStudent: Object.clone(defaultSAStudent),
      saStudentInfoDataIn: {
        studentId: 0,
        studentData: null,
      },
    };
  },
  created() {
    getMobileAppLink().then(result =>{
      if (!!result && result.success){
        this.mobileAppLink = result.data;
      }
    });
    this.initData();
  },
  components: {
    phoneEditor,
    navigator,
    universityEditor,
    passwordEditor,
    memberInfo,
    studentSpeedupCourseHistory,
    studentPaymentHistory,
    studentBounsPointHistory,
    studentBalanceHistory,
    studentReceiptHistory,
    emailEditor,
    saStudentInfo: () => import("@/components/studyAbroad/studentInfo"),
    studentSAServiceHistory: () => import("@/components/studyAbroad/history/studentSAServiceHistory"),
    studentSAServiceSummaryHistory: () => import("@/components/studyAbroad/history/studentSAServiceSummaryHistory"),
  },
  methods: {
    // 与服务端交互数据相关方法
    async loadStudentFromServer(type) {
      try {
        let result = await getStudent(this.currentStudentId);
        if (!!result && result.success) {
          this.$data.form.StudentId = result.data.Id;
          this.$data.form.Phone = result.data.Phone;
          this.$data.form.UniversityName = result.data.UniversityName;
          this.$data.form.UniversityId = result.data.UniversityId;
          this.$data.form.Email = result.data.Email;
          this.$data.form.IsStudyAbroad = result.data.IsStudyAbroad;
          if (!!type && type == "university") {
            setStore("user_student_universityName", result.data.UniversityName);
            let hasSaturdayCourse = 0;
            if (result.data.HasSaturdayCourse) {
              hasSaturdayCourse = 1;
            }
            setStore("user_student_hasSaturdayCourse", hasSaturdayCourse);
            let hasSundayCourse = 0;
            if (result.data.HasSundayCourse) {
              hasSundayCourse = 1;
            }
            setStore("user_student_hasSundayCourse", hasSundayCourse);
          } else if (!!type && type == "phone") {
            setStore("user_name", this.$data.form.Phone);
            this.$emit("logged-event");
          }
          if (!!this.$refs["member-info"])
            this.$refs["member-info"].loadStudentMemberInfo(
              this.$data.form.StudentId
            );
        }
      } catch (error) {
      }
    },
    async loadSAStudentFromServer() {
      if (!this.currentStudentId) return;

      try {
        let result = await getStudyAbroadStudent(this.currentStudentId);
        this.saStudent =
          !!result && result.success && !!result.data
            ? result.data
            : Object.clone(defaultSAStudent);
      } catch (error) {
      }

      this.resetSAStudentInfoDataIn();
    },
    async initData(type) {
      if (this.USERMANAGER.isStudent) {
        this.currentStudentId = Number(getStore("user_student_id"));
        this.isStudentHimself = true;
      } else {
        this.currentStudentId = Number(this.$route.query.studentId);
        this.isStudentHimself = false;
      }
      
      await this.loadStudentFromServer(type);
      await this.loadSAStudentFromServer();
    },

    // SAStudentInfo相关方法
    resetSAStudentInfoDataIn() {
      let studentData =
        !!this.saStudent && !!this.saStudent.StudentId ? this.saStudent : null;

      this.saStudentInfoDataIn = {
        studentId: !!studentData ? studentData.StudentId : this.studentId,
        studentData: studentData,
      };
    },

    edit(type) {
      if (type === "phone") {
        this.phoneEditorVisible = true;
      } else if (type === "university") {
        this.universityEditorVisible = true;
      } else if (type === "password") {
        this.passwordEditorVisible = true;
      } else if (type === "email") {
        this.emailEditorVisible = true;
      }
    },
    onCloseEditor(type) {
      if (type === "phone") {
        this.phoneEditorVisible = false;
      } else if (type === "university") {
        this.universityEditorVisible = false;
      } else if (type === "password") {
        this.passwordEditorVisible = false;
      } else if (type === "email") {
        this.emailEditorVisible = false;
      }
    },
    onSaveSuccess(type) {
      this.initData(type);
    },
    onBack() {
      this.$router.back(-1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/studentProfile.vue